import { render } from "./CreateOrder.vue?vue&type=template&id=800e8b0e"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__